import React, { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Footer } from '../../components/Footer/Footer.tsx';
import { Header } from '../../components/Header/Header.tsx';
import './Game.scss';
import { GameTest } from './components/GameTest.tsx';
export type IResult = 'BAD' | 'HALF' | 'FULL' | 'MISSING_ALERT' | null;

export const Game = () => {
	const container = useRef<HTMLDivElement>(null);
	const [searchParams] = useSearchParams();
	const requestedTestId = searchParams.get('testId') || undefined;

	const scrollToBottom = () => {
		container.current?.scrollIntoView({ behavior: 'smooth' });
	};

	useEffect(() => {
		scrollToBottom();
	}, [requestedTestId]);

	return (
		<div className="game wrapper wrapper--spaced">
			<Header />
			<div className="container">
				<GameTest id={requestedTestId} containerRef={container} scrollToBottom={scrollToBottom} />
			</div>
			<div className="game__mobileFiller"></div>
			<Footer />
		</div>
	);
};

export default Game;
